This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="header whole buttonsRight">
    <!-- Switch back to level maker button -->
    <div v-if="$store.getters.getIsPreview" class="tooltip">
      <button class="button neutral" @click="gotoEditor()">
        <img src="@/assets/images/icons/Theme.svg" alt="go back to editor" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.switchEditor") }}</p>
        <i></i>
      </div>
    </div>
    <!--ActionText for savebutton-->
    <div v-if="!editor && !run" class="tooltip">
      <button
        class="button warning"
        @click="
          this.$emit('setBreakpoint');
          breakpointOn = !breakpointOn;
        "
        :class="breakpointOn ? '' : 'unselected'"
      >
        <!--Breakpoint button-->
        <img
          v-if="breakpointOn"
          src="@/assets/images/icons/Pause.svg"
          alt="Breakpoint icon"
        />
        <img
          v-else
          src="@/assets/images/icons/PauseRed.svg"
          alt="Breakpoint icon"
        />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.breakpoint") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="false" class="tooltip">
      <button class="button neutral" style="display: none; pointer-events: none;" @click="this.$emit('changeMode')">
        Button to switch between code and PSD
        <img
          src="@/assets/images/icons/Switch.svg"
          alt="Switch between code and PSD icon"
        />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.psdSwitch") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="editor && !run && teacherPermission" class="tooltip">
      <button class="button neutral" @click="this.$emit('changeAnswerMode')">
        <!--Add levelmaker answer button-->
        <img src="@/assets/images/icons/Answer.svg" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.switchAnswer") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="!editor && !run && teacherPermission" class="tooltip">
      <button class="button neutral" @click="this.$emit('toggleSolution')">
        <!--Answer button-->
        <img src="@/assets/images/icons/Answer.svg" alt="Show answer icon" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.answer") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="!editor && run" class="tooltip">
      <button class="button neutral" @click="this.$emit('continue')">
        <!--Step over button-->
        <img src="@/assets/images/icons/Stepover.svg" alt="Step over icon" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.stepOver") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="(!run || editor) && levelMakerAnswer" class="tooltip">
      <button class="button neutral" @click="this.$emit('undo')">
        <!--Step back button-->
        <img src="@/assets/images/icons/Back.svg" alt="Step back icon" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.back") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="(!run || editor) && levelMakerAnswer" class="tooltip">
      <button class="button neutral" @click="this.$emit('redo')">
        <!--Step forward button-->
        <img src="@/assets/images/icons/Forward.svg" alt="Step forward icon" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.forward") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="run && !editor" class="tooltip">
      <button class="button warning" @click="this.$emit('stopRunning')">
        <!--Stop button-->
        <img
          src="@/assets/images/icons/Stop.svg"
          alt="Stop running code icon"
        />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.stop") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="!editor && !run" class="tooltip">
      <button class="button success" @click="this.$emit('runGame')">
        <!--Run button-->
        <img src="@/assets/images/icons/Run.svg" alt="Run code icon" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.run") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="editor || !run" class="tooltip">
      <button class="button success save" @click="this.$emit('saveGame')">
        <!--Save button-->
        <img src="@/assets/images/icons/Save.svg" alt="Save code icon" />
        <div v-if="saved == 'succeeded'" class="image">
          <img src="@/assets/images/icons/Check.svg" alt="Save success icon" />
        </div>
        <div v-else-if="saved == 'failed'" class="image">
          <img src="@/assets/images/icons/Cross.svg" alt="Save failed icon" />
        </div>
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.save") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="editor" class="tooltip">
      <button class="button success" @click="this.$emit('previewGame')">
        <!--Example button-->
        {{ $t("game.example") }}
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.example") }}</p>
        <i></i>
      </div>
    </div>
    <div v-if="editor" class="tooltip">
      <button class="button success">
        <!--Upload button-->
        <img src="@/assets/images/icons/Upload.svg" alt="Upload level icon" />
      </button>
      <div class="tooltipText top-6">
        <p>{{ $t("game.tooltips.upload") }}</p>
        <i></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import router from "@/router";

@Options({
  name: "button-block",
  data() {
    return {
      userInfo: null,
      levelSettings: null,
      breakpointOn: false,
    };
  },
  beforeMount() {
    this.userInfo = this.$store.getters.getUserInfo;
    this.levelSettings = this.$store.getters.getLevelSettings;
  },
  computed: {
    /**
     * Check if both PSD and written code are allowed
     * @returns Boolean if PSD and written code allowed
     */
    psdAndCode: function () {
      return this.levelSettings.allowPsd && this.levelSettings.allowWritten;
    },
    /**
     * Check if user has teacher or admin permission
     * @returns Boolean has permission
     */
    teacherPermission: function () {
      return (
        this.userInfo?.permissionLevel == "teacher" ||
        this.userInfo?.permissionLevel == "admin"
      );
    },
  },
  props: {
    saved: String,
    editor: Boolean,
    levelMakerAnswer: Boolean,
    run: Boolean,
  },
  methods: {
    // go back to the level editor view
    gotoEditor() {
      this.$store.commit("turnPreviewOff");
      router.push("/docent/levelmaker");
    },
  },
})
export default class ButtonBlock extends Vue {}
</script>
